export const absenceTypes: {name: string, value: string}[] = [
  {name: 'breastfeeding', value: 'breastfeeding'},
  {name: 'family-care', value: 'family_care'},
  {name: 'family-death', value: 'family_death'},
  {name: 'family-hospital', value: 'family_hospital'},
  {name: 'marriage', value: 'marriage'},
  {name: 'moving-home', value: 'moving_home'},
  {name: 'official-duties', value: 'official_duties'},
  {name: 'other', value: 'other'},
  {name: 'parenthood', value: 'parenthood'},
  {name: 'sickness', value: 'sickness'},
];